import { Fade } from "@mui/material";

export const TabPanel = ({ children, activeTab, value }) => {
  return (
    <Fade in={activeTab === value} unmountOnExit>
      <div
        role="tabpanel"
        hidden={value !== activeTab}
        id={`simple-tabpanel-${activeTab}`}
        aria-labelledby={`simple-tab-${activeTab}`}
      >
        {children}
      </div>
    </Fade>
  );
};
